// hooks/auth/useToken.ts
import { useState } from 'react';

const TOKEN_KEY = 'access_token';
const IZILIFE_TOKEN_KEY = 'izilife_token';

export default function useToken() {
  // Token Izi CallCenter
  const [token, setTokenState] = useState<any>(() => {
    return localStorage.getItem(TOKEN_KEY);
  });

  // Token Izilife Pay
  const [izilifeToken, setIzilifeTokenState] = useState<any>(() => {
    return localStorage.getItem(IZILIFE_TOKEN_KEY);
  });

  // Sauvegarder le token Izi CallCenter
  const saveToken = (token: any) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
    setTokenState(token);
  };

  // Sauvegarder le token Izilife
  const saveIzilifeToken = (token: any) => {
    if (token) {
      localStorage.setItem(IZILIFE_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(IZILIFE_TOKEN_KEY);
    }
    setIzilifeTokenState(token);
  };

  // Supprimer tous les tokens
  const clearToken = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(IZILIFE_TOKEN_KEY);
    setTokenState(null);
    setIzilifeTokenState(null);
  };

  // Sauvegarder les deux tokens en même temps (pour le login)
  const saveTokens = (accessToken: string, izilifeToken: string) => {
    saveToken(accessToken);
    saveIzilifeToken(izilifeToken);
  };

  return {
    token,
    izilifeToken,
    saveToken,
    saveIzilifeToken,
    saveTokens,
    clearToken,
    isAuthenticated: !!token,
  };
}